// Tier chips on product cards — switch displayed price + label.
// Markup contract (see template-parts/home/product-card-quick.php):
//   .product-quick[data-tiers='[{label,weight,price,default}, …]']
//     .product-quick__price     (Woo's <span class="woocommerce-Price-amount">)
//     .product-quick__tiers > .tier-chip[data-tier-price][data-tier-label]
//
// When a chip is clicked we replace the displayed price text and toggle
// the active class. Mutations stay client-side; cart add still uses
// the product's variation/parent ID (Woo handles real variations).

const CURRENCY = (window.HAEGOZIYA && window.HAEGOZIYA.currency) || '₪';

function fmtPrice(price) {
    const num = parseFloat(price);
    if (isNaN(num)) return '';
    return `${CURRENCY}${num.toFixed(0)}`;
}

function applyTier(card, chip) {
    const price = chip.getAttribute('data-tier-price');
    const priceEl = card.querySelector('.product-quick__price');
    if (priceEl && price) {
        // Preserve original Woo HTML on first run so future switches keep markup.
        if (!priceEl.dataset.original) priceEl.dataset.original = priceEl.innerHTML;
        priceEl.innerHTML = `<span class="woocommerce-Price-amount amount"><bdi>${fmtPrice(price)}</bdi></span>`;
    }
    card.querySelectorAll('.tier-chip').forEach(c => c.classList.toggle('is-active', c === chip));

    // Update price-per-100g if weight is provided.
    const tiers = (() => { try { return JSON.parse(card.dataset.tiers || '[]'); } catch (e) { return []; } })();
    const idx = parseInt(chip.dataset.tierIndex, 10);
    const tier = tiers[idx];
    const perEl = card.querySelector('.product-quick__per-unit');
    if (perEl && tier && tier.weight && tier.price) {
        const per100 = (parseFloat(tier.price) / parseFloat(tier.weight) * 100).toFixed(2);
        perEl.textContent = perEl.textContent.replace(/[\d.]+/, per100);
    }

    // Stash the selected tier on the card so quick-add can use it.
    card.dataset.activeTierPrice  = price || '';
    card.dataset.activeTierLabel  = chip.getAttribute('data-tier-label') || '';
    card.dataset.activeTierWeight = chip.getAttribute('data-tier-weight') || '';
    card.dataset.activeTierIndex  = chip.getAttribute('data-tier-index') || '';

    // Tell quick-add the active tier changed so it can repaint the +/- count
    // with THIS tier's quantity already in the cart (each tier is a separate
    // cart line — see inc/woocommerce.php).
    card.dispatchEvent(new CustomEvent('haegoziya:tier-changed', {
        detail: { index: parseInt(chip.getAttribute('data-tier-index') || '0', 10) },
    }));
}

document.addEventListener('click', e => {
    const chip = e.target.closest('.tier-chip');
    if (!chip) return;
    e.preventDefault();
    const card = chip.closest('.product-quick');
    if (!card) return;
    applyTier(card, chip);
});
